import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "clickStopper" };
const _hoisted_2 = { class: "opModal" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "text-right" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
    key: 1,
    class: "text-center message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_val_form = _resolveComponent("val-form");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "taskTitle" }, " ATTENZIONE - IL TUO ACCOUNT È STATO CONGELATO PER INUTILIZZO! ", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", null, " Purtroppo il tuo account è stato congelato temporaneamente in quanto è da più di un anno che non effettui l'accesso. I tuoi crediti sono comunque al sicuro, potrai sbloccare nuovamente il tuo account compilando il modulo qui in basso. ", -1)),
            (!_ctx.message)
                ? (_openBlock(), _createBlock(_component_val_form, {
                    key: 0,
                    class: "mt-4",
                    onSubmit: _ctx.sendMail
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[1] || (_cache[1] = _createElementVNode("label", null, "Messaggio", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.testoMail) = $event)),
                                rows: "8"
                            }, null, 512), [
                                [_vModelText, _ctx.testoMail]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-green",
                                disabled: !_ctx.canSend
                            }, " Invia richiesta ", 8, _hoisted_5)
                        ])
                    ]),
                    _: 1
                }, 8, ["onSubmit"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.message), 1))
        ])
    ]));
}
